import { verticalRequest } from './http';

// Paged. Query: `condo_id`, `unit_id`, `language`, `status` (`active` |
// `inactive` | `archived` | `all`; none = every tenant not archived), `search`
// (name, phone, unit name).
export const listTenants = params =>
  verticalRequest({ path: '/tenants', params });

// `{found: true, tenant_id, name, language, condo, unit, room, ...}` or
// `{found: false}`. The phone may be in any format (422 `invalid_phone`).
export const lookupTenant = phone =>
  verticalRequest({ path: '/tenants/lookup', params: { phone } });

// `{unit_id, room_id (rental only), name, phone, language, active}`. The phone
// is the bot's whitelist key: unique across tenants and service team members.
export const createTenant = fields =>
  verticalRequest({ method: 'post', path: '/tenants', data: fields });

export const updateTenant = (id, fields) =>
  verticalRequest({ method: 'put', path: `/tenants/${id}`, data: fields });

// Answers 200 `{id, result: 'deleted' | 'archived'}`: a tenant a ticket refers
// to is archived instead of deleted.
export const deleteTenant = id =>
  verticalRequest({ method: 'delete', path: `/tenants/${id}` });
